import React, { useState } from 'react';
import {
  setTranslations,
  setDefaultLanguage,
  setLanguageCookie,
  setLanguage,
  translate, getLanguage,
} from 'react-switch-lang';
import {
  ButtonDropdown, DropdownItem, DropdownMenu, DropdownToggle,
} from 'reactstrap';
import {
  English, Ukrainian, Russian,
} from '../../../constant';
import en from '../../../i18n/en.json';
import ua from '../../../i18n/uk.json';
import ru from '../../../i18n/ru.json';
import appState from '../../../storages/mobx/appState';

export const initTranslations = () => {
  setTranslations({
    en, ua, ru,
  });
  setDefaultLanguage('ua');
  setLanguageCookie('language', {}, 'language');
  // const lang = getLanguage();
  // // if (lang != 'ua') {
  // //
  // // }
  appState.setCurrentLanguage(getLanguage());
};

const Language = () => {
  const handleSetLanguage = (key) => {
    setLanguage(key);
    appState.setCurrentLanguage(key);
  };
  const [dropdownOpen, setOpen] = useState(false);
  return (
    <>
      <div className="language-dropdown">
        <ButtonDropdown isOpen={dropdownOpen} toggle={() => setOpen(!dropdownOpen)} className="language-dropdown p-20">
          <DropdownToggle caret>
            Button Dropdown
          </DropdownToggle>
          <DropdownMenu className="language-dropdownMenu">
            <DropdownItem header>Header</DropdownItem>
            <DropdownItem disabled>Action</DropdownItem>
            <DropdownItem onClick={() => handleSetLanguage('en')}>
              <a href="#javascript" data-lng="en">
                <i className="flag-icon flag-icon-us" />
                {' '}
                {English}
              </a>
            </DropdownItem>
            <DropdownItem onClick={() => handleSetLanguage('ru')}>
              <a href="#javascript" data-lng="ru">
                <i className="flag-icon flag-icon-ru" />
                {' '}
                {Russian}
              </a>
            </DropdownItem>
            <DropdownItem onClick={() => handleSetLanguage('ua')}>
              <a href="#javascript" data-lng="ua">
                <i className="flag-icon flag-icon-ua" />
                {' '}
                {Ukrainian}
              </a>
            </DropdownItem>
            <DropdownItem divider />
          </DropdownMenu>
        </ButtonDropdown>
      </div>
      {/* <div> */}
      {/*  <ul className="language-dropdown onhover-show-div p-20"> */}
      {/*    <li onClick={() => handleSetLanguage('en')}> */}
      {/*      <a href="#javascript" data-lng="en"> */}
      {/*        <i className="flag-icon flag-icon-us" /> */}
      {/*        {' '} */}
      {/*        {English} */}
      {/*      </a> */}
      {/*    </li> */}
      {/*    <li onClick={() => handleSetLanguage('ru')}> */}
      {/*      <a href="#javascript" data-lng="ru"> */}
      {/*        <i className="flag-icon flag-icon-ru" /> */}
      {/*        {' '} */}
      {/*        {Russian} */}
      {/*      </a> */}
      {/*    </li> */}
      {/*    <li onClick={() => handleSetLanguage('ua')}> */}
      {/*      <a href="#javascript" data-lng="ua"> */}
      {/*        <i className="flag-icon flag-icon-ua" /> */}
      {/*        {' '} */}
      {/*        {Ukrainian} */}
      {/*      </a> */}
      {/*    </li> */}
      {/*  </ul> */}
      {/* </div> */}
    </>
  );
};

export default translate(Language);
